import React from 'react'

const RtVideoEmbed = ({ value: { url }}) => (
	<iframe className="aspect-video w-full !my-8" src={url} />
)

export default RtVideoEmbed
